//import liraries
import React from 'react';
import { View } from 'react-native';
import { useCssStyle } from '../../customHook/getCssStyle';

const PaginationDots = (props) => {
  const { totalDots = 0, activeIndex, dotStyle, activeDotStyle } = props || {};
  const getStyles = useCssStyle();

  // Generate dots array
  const dots = Array.from({ length: totalDots }, (_, i) => i);

  return (
    <View style={getStyles(['paginationContainer'])}>
      {dots.map(i => (
        <View
          key={i}
          style={[getStyles(['paginationDot', dotStyle]), activeIndex === i && getStyles(['paginationActiveDot', activeDotStyle])]}
        />
      ))}
    </View>
  );
};

export default PaginationDots;
